module.exports = __webpack_public_path__ + "img/logo_pno.158090c1.png";